import { useEffect, useState, useCallback } from 'react';
import { Table, Pagination, Header, Message, Button } from 'react-frontier';
import { useUser } from '../HooksPublic';
import API from '../APIPublic';
import styles from '../style/user_account.module.scss';
import { isToday } from '../UtilPublic';
import { UserCredit } from '../ClassesPublic';
import moment from 'moment';

const CREDITS_PAGE_SIZE = 10;

var UserAccountPoints = () => {
   var { token } = useUser();
   var [credits, setCredits] = useState<UserCredit[]>(null);
   var [creditsError, setCreditsError] = useState<string>(null);
   var [creditsPage, setCreditsPage] = useState<number>(1);
   var [hasMoreCredits, setHasMoreCredits] = useState<boolean>(false);

   var loadCredits = useCallback((page: number = 1) => {
      setCreditsError(null);
      setCredits(null);
      if (!token || !token.access) {
         setCreditsError('No se encontró sesión activa.');
         return;
      }
      var offset = (page - 1) * CREDITS_PAGE_SIZE;
      API.getUserCredits(token.access, offset, CREDITS_PAGE_SIZE).then(res => {
         if (res.error) {
            setCreditsError(res.message || 'No fue posible cargar tus puntos');
            setCredits([]);
            setHasMoreCredits(false);
            return;
         }
         setCreditsPage(page);
         var creditsData = res.data || [];
         setCredits(creditsData);
         setHasMoreCredits(creditsData.length === CREDITS_PAGE_SIZE);
      }).catch(() => {
         setCreditsError('Hubo un error cargando tus puntos');
         setCredits([]);
         setHasMoreCredits(false);
      });
   }, [token && token.access]);

   useEffect(() => {
      if (!token) return;
      loadCredits(1);
   }, [token, loadCredits]);

   const handleOrderClick = (orderHash: string) => {
      window.open(`/order/${orderHash}`, '_blank');
   };

   return <div className={styles.flexColumn}>
         {!credits && !creditsError && (
            <div className={styles.centerPad40}>
               <Header loading text="Cargando puntos..." />
            </div>
         )}
         {creditsError && (
            <div className={styles.padding20}>
               <Message type="error" text={creditsError} />
            </div>
         )}
         {credits && !creditsError && (
            <div className={styles.tableScroll}>
               <Table
                  title='Movimientos de puntos'
                  titleCentered
                  striped
                  collapsingIndexes={[]}
                  headers={['No. de órden', 'Fecha', 'Estatus', 'Puntos']}
                  footer={
                     credits && !creditsError && (hasMoreCredits || creditsPage > 1) ? (
                        <tr>
                           <td colSpan={4} className={styles.paginationCell}>
                              <Pagination
                                 pageCount={hasMoreCredits ? creditsPage + 1 : creditsPage}
                                 page={creditsPage - 1}
                                 onPageChange={(page) => loadCredits(page + 1)}
                              />
                           </td>
                        </tr>
                     ) : null
                  }
               >
                  {credits.length === 0 && (
                     <Table.Row>
                        <Table.Cell colSpan={4} className={styles.emptyCell}>
                           <Header text="Aún no tienes puntos" size="small" iconName="star" subtext="Realiza compras para empezar a ganar puntos." />
                        </Table.Cell>
                     </Table.Row>
                  )}
                  {credits.length > 0 && credits.map(c => (
                     <Table.Row
                        key={`cr-${c.credit_id}`}
                        data={[
                           c.order_id ? <Button size="small" basic text={`CCN-${c.order_id}`} onClick={() => handleOrderClick(c.order_hash)} /> : '—',
                           <span
                              style={{
                                 color: isToday(c.date_created) ? 'green' : '#333',
                                 fontWeight: isToday(c.date_created) ? 'bold' : 'normal',
                              }}
                           >
                              {moment.unix(c.date_created).format('DD/MMM/YY')}
                           </span>,
                           c.deleted ? (
                              <span className={`fr small label red ${styles.fw600}`}>Eliminado</span>
                           ) : c.amount < 0 ? (
                              <span className={`fr small label red ${styles.fw600}`}>Canjeado</span>
                           ) : (
                              <span className={`fr small label green ${styles.fw600}`}>Activo</span>
                           ),
                           <span style={{ fontWeight: 700, fontSize: 16, color: c.deleted ? '#aaa' : (c.amount < 0 ? '#e74c3c' : '#27ae60') }}>
                              {c.amount > 0 ? `+${c.amount}` : c.amount} pts
                           </span>,
                        ]}
                     />
                  ))}
               </Table>
            </div>
         )}
   </div>
};

export default UserAccountPoints;
